import LeftNavNode from './LeftNavNode';

export default LeftNavNode;
